import React, { useEffect, useState } from "react";
import Layout from "../Components/Layout";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import contactUs from "../Assets/images/army-image.png";
import Heroes from "../Assets/images/heroes-image.png";
import { toast } from "react-toastify";
import { PostApiWithoutLogin } from "../apiService";
import { API_PATH } from "../const";
import Loader from "../Components/Layout/Loader";

function Donation(props) {
    const [show, setShow] = useState(false);
    const [options, set_options] = useState(1);
    const [amount, set_amount] = useState(null);
    const [modal_step, set_modal_step] = useState(1);
    const [name, set_name] = useState("");
    const [phone, set_phone] = useState(null);
    const [email, set_email] = useState("");
    const [stats, set_stats] = useState({});
    const [loader, set_loader] = useState(false);
    const [loader_text, set_loader_text] = useState("");
    

    useEffect(() => {
        FetchStats();
    }, [])

    const FetchStats = () => {
        set_loader(true);
        const FeaturedAdvData = Promise.resolve(PostApiWithoutLogin(API_PATH.GetPaymentStats, {reason: [3]}));
        FeaturedAdvData.then(response => {
            if(response.status === 200) set_stats(response?.data?.data ?? {});
            else set_stats({});
            set_loader(false);
        })
    }

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handle_modal_step = () => {
        if(modal_step === 1) set_modal_step(2);
        else donate();
    }

    const donate = () => {
        if(name === "" || email === "" || phone === null) {
            toast.error("Please do not leave any field empty.");
            return;
        }

        if(phone.length !== 10) {
            toast.error("Invalid contact number");
            return;
        }

        if(!email.includes("@")){
            toast.error("Invalid email");
            return;
        }

        let amt = 0;
        if(options === 1) amt=5000
        else if(options === 2) amt=10000
        else if(options === 3) amt=20000
        else amt = amount



        const data = {
            info: JSON.stringify({
                name,
                email,
                phone
            }),
            reason: 3,
            user_id: Number(phone),
            amount: Number(amt)
        }

        set_loader_text("Redirecting to payment link");
        set_loader(true);

        const PaymentInitation = Promise.resolve(PostApiWithoutLogin(API_PATH.PaymentInit, data));
        PaymentInitation.then(response => {
            const payment_url = response.data?.data?.checkoutPageUrl ?? "";
            if(payment_url !== "") window.location.href = payment_url; 
            else {
                toast.error("Could not generate payment url please try again later.");
                set_loader(false);
            }
        })
    }

    const FormatCurrency = (number) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR'
        }).format(number);
    }

    return (
        <Layout>
            {loader === true ? <Loader text={loader_text}></Loader> : <></>}
            <div className="heroes-main">
                <img src={Heroes} className="img-fluid img-main w-100 h-vh-div object-fit-cover" alt="contact us" />
                <div className="heroes-div-info">
                    <h2>
                        Support Our <span>Heroes,</span> Every <bdi>Rupee</bdi> Counts
                    </h2>
                    <p>
                        <span>Operation Sindoor</span> marks a proud chapter in our nation's history. As we celebrate its success, let us stand by the real heroes behind it — the brave soldiers of the Indian Army and their
                        families.
                    </p>
                    <img src={contactUs} className="img-fluid w-100" alt="contact us" />
                </div>
                <div className="heroes-div-info text-center heroes-div-btm">
                    <h2>{FormatCurrency(1000000 + Number(stats.total_amount ?? 0))}</h2>
                    <div className="progress mt-3 mb-1 progress-cust-info">
                        <div className="progress-bar" style={{ width: "20%" }}></div>
                    </div>
                    <div className="d-flex align-items-center mb-3">
                        <span className="text-span-cls">{512 + Number(stats.count ?? 0)} Contributions</span>
                        <span className="ms-auto text-span-cls">{((1000000 + Number(stats.total_amount ?? 0))/5000000 * 100).toFixed(1)}%</span>
                    </div>

                    <p>Join us in honoring the courage, sacrifice, and service of our soldiers. Your support is more than a donation</p>
                    <button type="button" className="button-div-act w-100" onClick={handleShow}>
                        Donate Now
                    </button>
                </div>
            </div>
            <Modal centered show={show} onHide={handleClose} className="mdl-army">
                <Modal.Body>
                    {modal_step === 1 && <div className="mb-4">
                        <h2 className="mb-3">This is not just charity — it’s gratitude in action.</h2>
                        <p>
                            We are committed to complete transparency. Every donation received through this platform goes directly to the welfare of Indian Army personnel and their families — for medical aid, education
                            support, rehabilitation, and martyr family assistance.
                        </p>
                        <ul>
                            <li>All funds are routed through official and verified channels.</li>
                            <li>Donation receipts and impact reports are provided.</li>
                            <li>Regular updates will show how your contributions are making a real difference.</li>
                        </ul>
                    </div>}
                    {modal_step === 2 && <div className="mb-4">
                        <h3 className="mb-3 fw-bold">Please provide us with your details for regular update on your donations</h3>
                        <form>
                            <div className="mb-3">
                                <label className="d-block pb-1 lbl-name-text">Name</label>
                                <input type="text" 
                                className="form-control styl-input fw-normal" 
                                placeholder="Enter You Name" 
                                value={name}
                                onChange={(e) => set_name(e.target.value)}
                                />
                            </div>
                            <div className="mb-3">
                                <label className="d-block pb-1 lbl-name-text">Contact Number</label>
                                <input type="number" 
                                className="form-control styl-input fw-normal" 
                                placeholder="Enter Your Contact Number" 
                                value={phone}
                                onChange={(e) => set_phone(e.target.value)}
                                />
                            </div>
                            <div className="mb-3">
                                <label className="d-block pb-1 lbl-name-text">Email</label>
                                <input type="email"
                                className="form-control styl-input fw-normal" 
                                placeholder="Enter Your Email" 
                                value={email}
                                onChange={(e) => set_email(e.target.value)}
                                />
                            </div>
                        </form>
                    </div>}
                    <div className="row">
                        <div className="col-6 mb-3 pb-2">
                            <button type="button" onClick={() => set_options(1)} className={options === 1 ? "w-100 button-div active" : "w-100 button-div"}>
                                ₹ 5,000{" "}
                            </button>
                        </div>
                        <div className="col-6 mb-3 pb-2">
                            <button type="button" onClick={() => set_options(2)} className={options === 2 ? "w-100 button-div active" : "w-100 button-div"}>
                                ₹ 10,000
                            </button>
                        </div>
                        <div className="col-6 mb-3 pb-2">
                            <button type="button" onClick={() => set_options(3)} className={options === 3 ? "w-100 button-div active" : "w-100 button-div"}>
                                ₹ 20,000{" "}
                            </button>
                        </div>
                        <div className="col-6 mb-3 pb-2">
                            <input type="number" value={amount} onChange={(e) => set_amount(e.target.value)} onFocus={() => set_options(4)}  className={options === 4 ? "control button-div active" : "control button-div"} placeholder="Enter Amount" />
                        </div>
                        <div className="col-6 mx-auto text-center mt-2">
                            <button onClick={() => handle_modal_step()} type="button" className="button-div-act w-100">
                                Donate Now
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </Layout>
    );
}

export default Donation;